import { get, post, put } from "./api_helper"

export const getOrderSheetAPI = params =>
  get("admin/master/order-sheet/creation/page", params)

export const getOrderSheetByIdAPI = id =>
  get(`admin/master/order-sheet/creation/${id}`)

export const putOrderSheetAPI = (data, id) =>
  put(`admin/master/order-sheet/creation/${id}`, data)
